import { css } from "@emotion/react";

import { animations, colors, layers } from "@styles";

export const style = css`
  width: 60px;
  height: 60px;
  background: ${colors.white};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: absolute;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  top: 50%;
  left: 50%;
  z-index: ${layers.zIndexMidForeground};
  margin-left: -30px;
  overflow: hidden;
`;

const loadingAnimationBase = css`
  position: absolute;
  animation: ${animations.spin};
  animation-duration: 1800ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  transform-origin: center;
  background-size: 100%;
`;

export const outerRingStyle = css`
  ${loadingAnimationBase}
  animation-delay: 300ms;
  height: 51px;
  width: 51px;
`;

export const middleRingStyle = css`
  ${loadingAnimationBase}
  transform: rotate(75deg);
  height: 43px;
  width: 43px;
`;

export const innerRingStyle = css`
  ${loadingAnimationBase}
  animation-direction: reverse;
  width: 34px;
  height: 34px;
`;

export const logoStyle = css`
  fill: ${colors.primary};
  width: 14px;
  height: 14px;
  top: 50%;
  left: 50%;
`;
